<template>
  <!-- 榆中县第一人民医院 -->
  <div class="pageContent">
    <div class="hosName">榆中县第一人民医院</div>
    <div class="ourterTitle">姓名/检查号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value73000005.name73000005"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value73000005.value1"
          placeholder="请输入检查号"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      rules: true,
      value73000005: {
        name73000005: "",
        value1: "",
      },
    };
  },
  methods: {
    inputFn() {
      if (this.value73000005.name73000005 != "" && this.value73000005.value1 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value73000005", JSON.stringify(this.value73000005));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name73000005")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  .hosName {
    font-size: 20px;
    // padding: 10px 0;
    padding: 65px 0 10px;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 15px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
